import {buildTimestampSchema} from '@nirby/store/base';
import {FIRESTORE_TIMESTAMP_SCHEMA} from '@nirby/store/firebase-web';
import {NirbyTimestamp, ZodSchemaBuild} from '@nirby/store/models';
import {DateTime} from 'luxon';

export const TIMESTAMP_SCHEMA: ZodSchemaBuild<NirbyTimestamp> = buildTimestampSchema(
    FIRESTORE_TIMESTAMP_SCHEMA.transform((value) => DateTime.fromJSDate(value.toDate())),
);
